"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TOOLTIP_OPENED_EVENT_NAME = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Help32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Help32PxOutlined"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _env = _interopRequireDefault(require("../../utils/env/env"));
var _detectTouchPoint = _interopRequireDefault(require("../../utils/touch/detectTouchPoint"));
var _tooltipModule = _interopRequireDefault(require("./tooltip.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TOOLTIP_OPENED_EVENT_NAME = exports.TOOLTIP_OPENED_EVENT_NAME = 'jl-ui-kit.tooltip.opened';
var Tooltip = function Tooltip(_ref) {
  var _ref$showContent = _ref.showContent,
    showContent = _ref$showContent === void 0 ? false : _ref$showContent,
    _ref$popoverClassname = _ref.popoverClassname,
    popoverClassname = _ref$popoverClassname === void 0 ? undefined : _ref$popoverClassname,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'tooltipID' : _ref$id,
    _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? '' : _ref$buttonLabel,
    _ref$anchor = _ref.anchor,
    anchor = _ref$anchor === void 0 ? 'center' : _ref$anchor,
    _ref$verticalAnchor = _ref.verticalAnchor,
    verticalAnchor = _ref$verticalAnchor === void 0 ? '' : _ref$verticalAnchor,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? '' : _ref$dataTestid,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? false : _ref$icon,
    _ref$modalHeaderClass = _ref.modalHeaderClassName,
    modalHeaderClassName = _ref$modalHeaderClass === void 0 ? '' : _ref$modalHeaderClass,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    ariaLabel = _ref.ariaLabel,
    ariaDescribedBy = _ref.ariaDescribedBy,
    children = _ref.children;
  // State for managing tooltip content visibility, vertical alignment, and scroll position
  var _useState = (0, _react.useState)(showContent),
    _useState2 = _slicedToArray(_useState, 2),
    contentOpen = _useState2[0],
    setContentOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(verticalAnchor || 'top'),
    _useState4 = _slicedToArray(_useState3, 2),
    currentVerticalAnchor = _useState4[0],
    setCurrentVerticalAnchor = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollStartPosition = _useState6[0],
    setScrollStartPosition = _useState6[1];

  // Refs for the tooltip button and popover
  var tooltipRef = (0, _react.useRef)(null);
  var tooltipPopoverRef = (0, _react.useRef)(null);

  // Handler to open the tooltip
  var openTooltip = (0, _react.useCallback)(function () {
    setContentOpen(true);
    if (_env["default"].isClient) {
      window.addEventListener('click', windowClickListener);
      window.addEventListener('keydown', windowEscapeListener);
      window.dispatchEvent(new CustomEvent(TOOLTIP_OPENED_EVENT_NAME, {
        detail: {
          id: id
        }
      }));
    }
  }, [id]);

  // Handler to close the tooltip
  var closeTooltip = (0, _react.useCallback)(function () {
    var tooltipClosedManually = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!contentOpen) {
      return;
    }
    setContentOpen(false);
    onClose(tooltipClosedManually);
    if (_env["default"].isClient) {
      window.removeEventListener('click', windowClickListener);
      window.removeEventListener('keydown', windowEscapeListener);
      if ((0, _get["default"])(tooltipRef, 'current.querySelector')) {
        var launchButton = tooltipRef.current.querySelector('button');
        if (launchButton && launchButton.focus) {
          launchButton.focus();
        }
      }
    }
  }, [contentOpen, onClose]);

  // Handler to manage the tooltip popover close
  var onPopOverClose = function onPopOverClose(e) {
    var _e$currentTarget$data;
    var tooltipClosedManually = ((_e$currentTarget$data = e.currentTarget.dataset) === null || _e$currentTarget$data === void 0 ? void 0 : _e$currentTarget$data.test) === 'tooltip-popover-close-button';
    closeTooltip(tooltipClosedManually);
  };

  // Handler to manage click events
  var onClick = function onClick() {
    if (contentOpen) {
      closeTooltip(true);
    } else {
      openTooltip();
    }
  };

  // Handler to manage button touch start
  var onButtonTouchStart = function onButtonTouchStart() {
    setScrollStartPosition(window.scrollY);
  };

  // Handler to manage button touch end
  var onButtonTouchEnd = function onButtonTouchEnd(evt) {
    evt.preventDefault();
    var scrollEndPosition = window.scrollY;
    if (!(scrollEndPosition > scrollStartPosition + 5)) {
      if (contentOpen) {
        closeTooltip(true);
        return;
      }
      openTooltip();
    }
  };

  // Handler for click events outside the tooltip
  var windowClickListener = function windowClickListener(event) {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      closeTooltip();
    }
  };

  // Handler for escape key press
  var windowEscapeListener = function windowEscapeListener(event) {
    if (tooltipRef.current && event.key === 'Escape') {
      closeTooltip(true);
    }
  };

  // Handler to check if the tooltip should close on page area touch
  var pageAreaCheck = function pageAreaCheck(e) {
    if (tooltipPopoverRef.current) {
      if (!(0, _detectTouchPoint["default"])(tooltipPopoverRef.current, e)) {
        onPopOverClose(e);
      }
    }
  };

  // Callback for intersection observer
  var intersectionObserverCallback = function intersectionObserverCallback(entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio !== 1 && contentOpen) {
        setContentOpen(false);
      }
    });
  };

  // Initial setup of intersection observer
  var initIntersectionObserver = (0, _react.useCallback)(function () {
    if (tooltipRef.current) {
      var observer = new IntersectionObserver(intersectionObserverCallback, {
        threshold: 1
      });
      observer.observe(tooltipRef.current);
      return observer;
    }
  }, [contentOpen]);

  // Cleanup of intersection observer
  var removeIntersectionObserver = (0, _react.useCallback)(function (observer) {
    if (observer && tooltipRef.current) {
      observer.unobserve(tooltipRef.current);
    }
  }, []);

  // Position the tooltip popover based on space availability
  var positionTooltipPopover = (0, _react.useCallback)(function () {
    var defaultMargin = 16;
    if (tooltipRef.current && tooltipPopoverRef.current) {
      var tooltipPosition = tooltipRef.current.getBoundingClientRect();
      var availableSpaceAbove = tooltipPosition.top;
      var tooltipPopoverHeight = tooltipPopoverRef.current.clientHeight + defaultMargin;
      var modalSpaceAbove = 0;
      if (modalHeaderClassName) {
        var modalHeader = document.querySelector(".".concat(modalHeaderClassName));
        if (modalHeader) {
          var modalHeaderPosition = modalHeader.getBoundingClientRect();
          modalSpaceAbove = modalHeaderPosition.bottom;
        }
      }
      var _verticalAnchor = tooltipPopoverHeight < availableSpaceAbove - modalSpaceAbove ? 'top' : 'bottom';
      setCurrentVerticalAnchor(_verticalAnchor);
    }
  }, [modalHeaderClassName]);
  (0, _react.useEffect)(function () {
    if (contentOpen) {
      positionTooltipPopover();
      onOpen();
      if (_env["default"].isClient) {
        window.addEventListener('click', windowClickListener);
        window.addEventListener('keydown', windowEscapeListener);
      }
    }
    if (_env["default"].isClient) {
      window.addEventListener('resize', positionTooltipPopover);
      window.addEventListener('touchstart', pageAreaCheck);
      window.addEventListener(TOOLTIP_OPENED_EVENT_NAME, onOpen);
      var observer = initIntersectionObserver();
      return function () {
        window.removeEventListener('click', windowClickListener);
        window.removeEventListener('keydown', windowEscapeListener);
        window.removeEventListener('resize', positionTooltipPopover);
        window.removeEventListener('touchstart', pageAreaCheck);
        window.removeEventListener(TOOLTIP_OPENED_EVENT_NAME, onOpen);
        removeIntersectionObserver(observer);
      };
    }
  }, [contentOpen, onOpen, pageAreaCheck, positionTooltipPopover, removeIntersectionObserver, initIntersectionObserver, windowClickListener, windowEscapeListener]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: tooltipRef,
    role: "tooltip",
    "aria-label": ariaLabel,
    className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip'], _defineProperty(_defineProperty({}, _tooltipModule["default"]['c-tooltip--under'], currentVerticalAnchor === 'bottom'), _tooltipModule["default"]['c-tooltip--open'], contentOpen)),
    "data-testid": dataTestId,
    "data-jlds": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      "aria-label": "tooltip",
      "aria-describedby": ariaDescribedBy,
      onClick: onClick,
      onTouchStart: onButtonTouchStart,
      onTouchEnd: onButtonTouchEnd,
      className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip__button'], _defineProperty({}, _tooltipModule["default"]['c-tooltip__button--with-icon'], icon || buttonLabel === '')),
      type: "button",
      "data-testid": "tooltip-text-button",
      children: [buttonLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: buttonLabel
      }), (icon || buttonLabel === '') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help32PxOutlined["default"], {})]
    }), contentOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames["default"])(_tooltipModule["default"]['c-tooltip-popover'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _tooltipModule["default"]['c-tooltip-popover--top'], currentVerticalAnchor === 'top'), _tooltipModule["default"]['c-tooltip-popover--bottom'], currentVerticalAnchor === 'bottom'), _tooltipModule["default"]['c-tooltip-popover--left'], anchor === 'left'), _tooltipModule["default"]['c-tooltip-popover--right'], anchor === 'right'), _tooltipModule["default"]['c-tooltip-popover--center'], anchor === 'center'), _tooltipModule["default"]['c-tooltip-popover--with-icon'], icon || buttonLabel === ''), _tooltipModule["default"]['c-tooltip-popover--with-label'], buttonLabel)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ref: tooltipPopoverRef,
        className: (0, _classnames["default"])(popoverClassname, _tooltipModule["default"]['c-tooltip-popover__inner']),
        "data-testid": "tooltip-popover-inner",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          onClick: onPopOverClose,
          className: _tooltipModule["default"]['c-tooltip-popover__closeButton'],
          "data-testid": "tooltip-popover-close-button",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _tooltipModule["default"]['c-tooltip-popover__closeButtonText'],
            children: "Close information"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _tooltipModule["default"]['c-tooltip-popover__closeButtonIcon'],
            "data-testid": "tooltip-icon"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _tooltipModule["default"]['c-tooltip-popover__content'],
          "data-testid": "tooltip-popover-content",
          role: "alert",
          children: children
        })]
      })
    })]
  });
};
Tooltip.propTypes = {
  showContent: _propTypes["default"].bool,
  popoverClassname: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string.isRequired,
  buttonLabel: _staticContentPropCheck["default"],
  anchor: _propTypes["default"].oneOf(['left', 'center', 'right']),
  verticalAnchor: _propTypes["default"].oneOf(['top', 'bottom', '']),
  'data-testid': _propTypes["default"].string,
  icon: _propTypes["default"].bool,
  modalHeaderClassName: _propTypes["default"].string,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string,
  ariaDescribedBy: _propTypes["default"].string
};
var _default = exports["default"] = Tooltip;